module.exports = __webpack_public_path__ + "static/paystack_docs_seo_image-83f4c473def81307a806441187742be6.jpg";